import { render, staticRenderFns } from "./TaxType.vue?vue&type=template&id=b32ec1ae&scoped=true&"
import script from "./TaxType.vue?vue&type=script&lang=js&"
export * from "./TaxType.vue?vue&type=script&lang=js&"
import style0 from "./TaxType.vue?vue&type=style&index=0&id=b32ec1ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32ec1ae",
  null
  
)

export default component.exports